export default function TaskDetails({ task }) {
  return [task.name, task.project?.name].filter(Boolean).join(' - ');
}
